<template>
  <div>
    <div class="container-fluid container-froDesk">
      <div class="wrapper">
        <div class="content-page content-froDesk">
          <div class="content">
            <div class="row">
              <!-- 科研成果 -->
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <div class="dropdown float-right">
                      <ol class="breadcrumb m-0 p-0">
                        <li class="breadcrumb-item"><a href="javascript: void(0);">首页</a></li>
                        <li class="breadcrumb-item"><a href="javascript: void(0);">科研成果</a></li>
                        <li class="breadcrumb-item active">搜索结果</li>
                      </ol>
                    </div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">搜索结果</span>
                      <span class="ml-1">Search Result</span>
                    </h3>
                    <!-- 筛选top -->
                    <div class="conditionTop mt-n2 clearfix">
                      <div class="conditionLeft">
                        <form>
                          <div class="form-row ml-0 mr-0">
                            <div class="form-row ml-0 mr-0 pt-2">
                              <div class="form-group">
                                <!-- <label for="inputState" class="col-form-label">关键字：</label> -->
                                <input type="search" class="form-control" id="inputState" placeholder="请输入标题">
                              </div>
                              <div class="form-group">
                                <!-- <label for="inputResults" class="col-form-label">成果形式：</label> -->
                                <select id="inputResults" class="form-control">
                                  <option>-请选择成果形式-</option>
                                  <option>成果形式 1</option>
                                  <option>成果形式 2</option>
                                  <option>成果形式 3</option>
                                </select>
                              </div>
                              <div class="form-group">
                                <!-- <label for="inputDate" class="col-form-label">年度：</label> -->
                                <input type="text" class="form-control" id="inputDate" data-provide="datepicker" data-date-format="yyyy年" data-date-min-view-mode="2" placeholder="选择获奖年度">
                              </div>
                              <div class="form-group">
                                <!-- <label class="col-form-label" style="opacity: 0;">搜索:</label> -->
                                <button type="button" class="btn btn-success form-control">搜索</button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="General-lists">
                      <ul class="froDesk-Lists mb-3">
                        <li class="li_3" v-for="item in 15" :key="item">
                          <i class="mdi mdi-arrow-right"></i>
                          <a href="">区委副书记、区长薛侃带队调研内江路小学迁建工程区委副书记、区长薛侃带队调研内江路小学迁建工程</a>
                          <span class="achievements">成果形式 1</span>
                          <span class="time">2020-01-27</span>
                        </li>
                      </ul>
                      <el-pagination :page-size="query.pageSize" layout="prev, pager, next" :total="total" @current-change="handlePageChange"></el-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end 科研成果-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "searchList",
  data() {
    return {
      query: {
        pageNumber: 1,
        pageSize: 15,
        pageSorts: [{ asc: true, column: "" }],
      },
      total: 0,
    };
  },
  mounted() {},
  methods: {
    toPage(url) {
      if (!url) return;
      this.$router.push(url);
    },
    // 分页器
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData();
    },
  },
};
</script>

<style>
/* 分页器样式 */
.el-pagination {
  text-align: right;
}
.el-pager li {
  margin: 0 4px;
  padding: 0;
  font-size: 13px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
}
.el-pager li.active {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
  border-radius: 50%;
}
.el-pager li.active:hover {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
}
.el-pager li:hover {
  color: #313a46;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
  border-radius: 50%;
}
</style>